import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useStationsStore = defineStore('stations', () => {
  const stations = ref<any[]>([])
  return { stations }
})
